import React, { Component } from 'react';
import CheckBoxList from './CheckBoxList';
import { withRouter } from 'react-router-dom';

class RolesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAllSelected: false,
            checkList: []
        };
    }

    render() {
        return (
            <div className="role-list">
                <CheckBoxList
                    options={this.props.checkList}
                    isCheckedAll={this.props.isAllSelected}
                    onCheck={this.props.onCheck}
                />
            </div>
        );
    }
}

export default withRouter(RolesList);